import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();

    const isHomePage = 
        location.pathname === "/" || 
        location.pathname === "" || 
        location.pathname === "/home" ||
        location.pathname.startsWith("/#");

    useEffect(() => {
        if (isHomePage) {
            setIsVisible(false);
            return;
        }

        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, [isHomePage]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    // Do not show on home page or when not scrolled
    if (isHomePage || !isVisible) return null;

    return (
        <button 
            className="fixed bottom-10 right-10 z-[150] p-1 text-black hover:scale-110 transition-transform duration-300 drop-shadow-md bg-white rounded-full"
            onClick={scrollToTop}
            aria-label="Scroll to top"
            title="Scroll to top"
        >
            <svg className="w-10 h-10 text-black" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="12" cy="12" r="10" strokeWidth="2" />
                <path d="M12 16V8M8 12l4-4 4 4" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </button>
    );
};

export default ScrollToTopButton;
